import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CmsComponent } from "./cms";
import {RunScriptsDirectiveModule} from '@signature-it/ngx-generic/directives';
import {CmsLinkModuleGeneric} from './cms-link/cms-link.module';
import {SafePipeModule, ReplaceTokensPipeArrayModule} from "@signature-it/ngx-generic/pipes";

@NgModule({
    declarations: [CmsComponent],
    imports: [
        CommonModule,
        CmsLinkModuleGeneric,
        RunScriptsDirectiveModule,
        SafePipeModule,
	ReplaceTokensPipeArrayModule
    ],
    exports: [CmsComponent]
})
export class CmsModule {}
